var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCallClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#F25540"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4312 23.428L16.2806 23.428C17.2982 23.428 17.9596 22.3595 17.5017 21.4945C17.1964 20.8839 17.4508 20.1207 18.0105 19.7646C19.2826 19.0013 21.9793 18.9505 23.3022 19.7646C23.9128 20.0699 24.1163 20.884 23.811 21.4945C23.3531 22.3595 24.0145 23.428 25.0321 23.428L27.8815 23.428C28.6447 23.3771 29.2553 22.7666 29.2553 22.0542L29.2553 20.1207C29.2044 18.1364 25.4392 16.5082 20.6563 16.5082C15.8735 16.5082 12.0574 18.0855 12.0574 20.1207V22.0542C12.1083 22.8174 12.7188 23.428 13.4312 23.428Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallClose);
export default __webpack_public_path__ + "static/media/video-call-close.24cd86955b0b715265ea2352134983ab.svg";
export { ForwardRef as ReactComponent };